import styled from 'styled-components';
import { BasketPxDetailsStyled } from '../../BasketPxDetailsStyled';

export const BasketPxDetailsOV = styled(BasketPxDetailsStyled)`
    .description {
        font-family: ${({ theme }) => theme.fonts.fontSecondary};
        .titleWrapper {
            .title {
                font-size: ${({ theme }) => theme.fontSizes.h3};
            }
        }
    }
`;
